import { createAction, props } from '@ngrx/store';
import AppError from 'src/app/model/app-error';
import { InsuredImportResponse } from 'src/app/model/insured-import.model';

export enum InsuredImportActions {
  InsuredImportStart = '[Insured Import] Start',
  InsuredImportSuccess = '[Insured Import] Success',
  InsuredImportError = '[Insured Import] Error',
  InsuredImportReset = '[Insured Import] Reset',
  InsuredImportSuccessfullyImported = '[Insured Import] Successfully Imported',
}

const start = createAction(InsuredImportActions.InsuredImportStart, props<{ payload: File }>());
const success = createAction(InsuredImportActions.InsuredImportSuccess, props<{ success: InsuredImportResponse }>());
const error = createAction(InsuredImportActions.InsuredImportError, props<{ error: AppError | null }>());
const reset = createAction(InsuredImportActions.InsuredImportReset);
const succesfullyImported = createAction(InsuredImportActions.InsuredImportSuccessfullyImported, props<{ importedToForm: boolean }>());

const processActions = {
  start,
  success,
  error,
  reset,
  succesfullyImported,
};

export default processActions;
